import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const AllEvents = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "Events";

  const title = "Events";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title> Events | Money Service Business Advocacy UK</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Events | Money Service Business Advocacy UK "
        />
        <meta property="og:description" content="" />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{
                    display: "inline-block",
                    marginRight: letter === " " ? "0.3rem" : "0",
                    whiteSpace: "pre",
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/whats-happening">What's Happening</NavLink>
              </li>
              <li className="active">
                <a href="#!">Events</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row justify-content-center">
              <div
                className="col-md-6 col-lg-6 col-xl-4 mix trending featured"
                data-bound
              >
                <div className="course-single-item">
                  <div className="d-block course-single-item-img">
                    <img
                      src="assets/images/meetup-2026/annual-meetup-2026.png"
                      alt="Annual Members Meet 2026"
                    />
                  </div>
                  <div className="course-single-item-content-bg">
                    <div className="course-single-item-content">
                      <div className="badge bg-primary text-dark mb-2">16th April 2026</div>
                      <h3>
                        <NavLink to="/annual-members-meet-2026">
                          MSB Association Annual Members Meet 2026
                        </NavLink>
                      </h3>
                      <p>
                        What an Evening! A Powerful Gathering of Insight, Leadership & Industry Collaboration. On Thursday, 16th April 2026, the MSB community came together once again...
                      </p>
                    </div>
                    <div className="d-flex justify-content-center course-single-item-price-cart">
                      <NavLink
                        to="/annual-members-meet-2026"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Read More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="col-md-6 col-lg-6 col-xl-4 mix trending featured"
                data-bound
              >
                <div className="course-single-item">
                  <div className="d-block course-single-item-img">
                    <img
                      src="assets/images/events/welcome-meet-june.png"
                      alt="Welcome Meet 2025"
                    />
                  </div>
                  <div className="course-single-item-content-bg">
                    <div className="course-single-item-content">
                      <div className="badge bg-primary text-dark mb-2">19th June 2025</div>
                      <h3>
                        <NavLink to="/welcome-msb-meet-june-2025">
                          Welcome MSB Meet-Up 19th June 2025
                        </NavLink>
                      </h3>
                      <p>
                        On Thursday, 19th June 2025, we brought the MSB community together—live in London. Hosted at McDermott Will & Emery UK LLP, 22 Bishopsgate...
                      </p>
                    </div>
                    <div className="d-flex justify-content-center course-single-item-price-cart">
                      <NavLink
                        to="/welcome-msb-meet-june-2025"
                        className="btn btn-primary btn-hover-secondary"
                      >
                        Read More
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AllEvents;
